import IvsContent from './IvsContent';

export default IvsContent;
